export class EmbedPBIModel {
    EmbedToken: string;
    EmbedUrl: string;
    ReportId: string;
  }
